<script setup lang="ts">
import { useGlobalStore } from "@/stores";

const globalStore = useGlobalStore();
</script>

<template>
    <div class="gift-card-offer">
        <div class="image-div">
            <img
                v-if="globalStore.incentiveAmount === 100"
                id="incentive-image-100"
                src="@img/incentive-image-100.png"
                alt="current incentive"
            />
        </div>
        <div class="description">
            Receive a
            <br />
            Gift card after you
            <br />
            take out cover.
        </div>
        <a
            href="https://www.tsb.co.uk/content/dam/tsb-public/documents/insurance/over-50-voucher-offer/over-50s-fixed-life-voucher-tsandcs.pdf"
            class="terms"
        >
            T&C apply
        </a>
    </div>
</template>

<style scoped>
.gift-card-offer {
    background-color: #aee6ff;
    border-radius: 10px;
    text-align: center;
    padding: 16px;
    margin-top: 20px;
    max-width: 660px;
    max-height: 490px;
}

.gift-card-offer .description {
    color: #0075d6;
    margin: 10px 0;
    font-family: Roboto, Arial, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
}

.gift-card-offer .terms {
    display: inline-block;
    margin-top: 10px;
    font-size: 16px;
    color: #0073e6;
    text-decoration: none;
    font-weight: bold;
}

.gift-card-offer .terms:hover {
    text-decoration: underline;
}
</style>
